<template>
  <div>
    <div class="pay-wait" style="background-color:#e6f0f5;">
      <div class="order_success order_success_o">
        <p>
          <span id="count">{{count}}</span>正等待微信返回结果...
        </p>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: "PayWeixinWait",
  componentName: "PayWeixinWait",
  components: {

  },
  data () {
    return {
      orderId: '',
      amountType: '',
      outTradeNo: '',
      count: 5,
      intervalId: null
    }
  },
  created () {
    this.orderId = this.$route.query.order_id
    this.amountType = this.$route.query.amount_type
    if (!this.orderId || !this.amountType) {
      this.$msg('参数异常', 'error') //TODO
      return
    }
    this.outTradeNo = this.$route.query.out_trade_no

    this.intervalId = setInterval(this.countDown, 1000);
  },
  mounted () {

  },
  methods: {
    countDown () {
      this.count--;
      console.log('interval ' + this.count);
      if (this.count <= 0) {
        clearInterval(this.intervalId);
        console.log('interval clear ' + this.intervalId);
        this.$router.push({ name: 'payResult', query: { order_id: this.orderId, amount_type: this.amountType, out_trade_no: this.outTradeNo } });
      }
    }

  }
}
</script>
<style scoped>
.pay-wait {
  margin: 100px auto;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/pay/payWeixinWait.vue